import { envconfig, EnvConfigType, EnvironmentType } from './environment.config'
const { REACT_APP_ENV } = process.env

export const config = {
  ...process.env,
  ...((envconfig as EnvConfigType)[REACT_APP_ENV || 'development'] as EnvironmentType),
}
